module.exports = {
  pleaseWait: 'ခဏစောင့်ပါ',
  loadMore: 'နောက်ထပ်ဖွင့်ရန် ဆွဲပါ',
  loadMore2: 'နောက်ထပ်မရှိတော့ပါ',
  FAQ: 'သိလိုရာများ',
  TC: 'စည်းမျဥ်းများ',
  Login: 'ဝင်ရန်',
  getCode: 'OTP ပို့ပါ',
  loginTips: 'ဖုန်းနံပါတ်ဖြည့်ပါ',
  phoneNumber: 'ဖုန်းနံပါတ်',
  Daily: 'နေ့စဥ်',
  Weekly: 'အပတ်စဥ်',
  Monthly: 'လစဉ်',
  Subscribe: 'စာရင်းသွင်းပါ',
  re_sub_tip: 'သင်ဝန်ဆောင်မှုကို ပယ်ဖျက်ပြီးပြီလား?',
  subscribe: 'စာရင်းသွင်းပါ',
  otpTips: 'ကျေးဇူးပြု၍ OTP ကို ထည့်သွင်းပါ',
  enter_otp: 'ကျေးဇူးပြု၍ OTP ကို ထည့်သွင်းပါ',
  free: 'အခမဲ့'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js